import {NgModule} from '@angular/core';
import {DeepLinker, IonicPageModule} from 'ionic-angular';
import {PruefungPage} from "./pruefung";
import {PruefungPdfPage} from "../pruefung-pdf/pruefung-pdf";
import {HelpModule} from "../../components/help/help.module";
import {NgPipesModule, PairsPipe} from "ngx-pipes";
import {PruefungAllgemeinModule} from "../pruefung-allgemein/pruefung-allgemein.module";
import {PruefungStandortModule} from "../pruefung-standort/pruefung-standort.module";
import {PruefungKundeModule} from "../pruefung-kunde/pruefung-kunde.module";
import {PruefungProtokolleModule} from "../pruefung-protokolle/pruefung-protokolle.module";

@NgModule({
  declarations: [
    PruefungPage,
    PruefungPdfPage,
  ],
  entryComponents: [
    PruefungPage,
    PruefungPdfPage,
  ],
  imports: [
    IonicPageModule.forChild(PruefungPage),
    PruefungAllgemeinModule,
    PruefungStandortModule,
    PruefungKundeModule,
    PruefungProtokolleModule,
    HelpModule,
    NgPipesModule
  ],
  providers: [
    PairsPipe,
  ]
})
export class PruefungModule {}



// WEBPACK FOOTER //
// ./src/pages/pruefung/pruefung.module.ts